import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Card } from "../cards/Card";
import "./TotpQrcode.scss";
import { encode } from "../../network/Encode";
export const TotpQrcode = ({ tin, secret, linkDescription, manualSetupDescription, }) => {
    const issuer = "Lysa AB";
    const uri = encode `otpauth://totp/${issuer}:${tin}?secret=${secret}&issuer=${issuer}&digits=6&period=30`;
    return (React.createElement(Card, { className: "totp-qrcode" },
        React.createElement("div", { className: "wrapper-div" },
            React.createElement("div", { className: "link-only" },
                linkDescription,
                React.createElement("br", null),
                React.createElement("a", { href: uri }, secret)),
            React.createElement("div", { className: "qr-code" },
                React.createElement(QRCodeSVG, { value: uri }),
                React.createElement("br", null),
                manualSetupDescription,
                React.createElement("br", null),
                React.createElement("a", { href: uri }, secret)))));
};
